import styled from '@emotion/styled';

import { Breakpoints } from 'utils/const.styles';

export const Container = styled.div`
	margin: auto;
	display: flex;
	flex-direction: column;
`;

export const FeedBackContentWrapper = styled.div`
	padding: 3rem 3rem;
`;

export const FeedBackInfo = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	margin: 2rem 0;
	gap: 4rem;

	> :last-child {
		span {
			text-align: right;

			body[dir='rtl'] & {
				text-align: left;
			}

			@media ${Breakpoints.mobileLandscape} {
				text-align: left;
			}
		}
	}

	.infoLabel {
		span {
			display: flex;
			flex-direction: column;
			gap: 0.64rem;
		}
	}

	&.mobileView {
		flex-direction: column;

		> :last-child span {
			text-align: unset;
		}
	}

	@media ${Breakpoints.mobileLandscape} {
		flex-direction: column;
	}
`;

export const FeedBackInfoCustomWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.64rem;
`;
export const FeedBackInfoCustomInfo = styled.div`
	display: flex;
	flex-direction: row;
	gap: 0.64rem;
`;

export const FeedBackInfoImage = styled.div`
	width: 5.5rem;
	height: 5.5rem;
	border-radius: 0.43rem;
	overflow: hidden;
`;
export const FeedBackInfoContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
`;

export const FeedBackForm = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2rem;
	margin-bottom: 4rem;
`;
export const FeedBackFormRow = styled.div`
	display: flex;
	flex-direction: column;

	> .typography {
		white-space: normal;
	}
`;

export const StarWrapper = styled.div`
	display: flex;
	align-items: center;
`;
export const AccordionInner = styled.div`
	display: flex;
	justify-content: space-between;
`;

export const UploadFileWrapper = styled.div`
	padding: 1rem 0;
	display: grid;
	grid-template-columns: repeat(5, minmax(0, 1fr));

	&.mobileView {
		grid-template-columns: repeat(1, minmax(0, 1fr));
	}

	@media ${Breakpoints.mobileLandscape} {
		grid-template-columns: repeat(1, minmax(0, 1fr));
	}
`;

export const Line = styled.span`
	height: 1px;
	min-height: 1px;
	background-color: var(--border-color);
	width: 100%;

	margin: 4.5rem auto;
	display: block;
`;

export const ItemInfo = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
`;
